import { queryOptions, useQuery } from '@tanstack/react-query';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

/** Whole list, capped at 2,000 by the backend; no cursor. */
export function variantsQueryOptions(productId: string) {
  return queryOptions({
    queryKey: productKeys.variants(productId),
    queryFn: () => productsApi.listVariants(productId),
  });
}

/** Null before the product exists. */
export function useVariants(productId: string | null) {
  return useQuery({ ...variantsQueryOptions(productId ?? ''), enabled: productId !== null });
}
